import { FC } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  PersonOutlined as Person,
  EmailOutlined as Email,
  PhoneIphoneOutlined as Phone,
  PsychologyOutlined as Therapist,
} from "@mui/icons-material";

import {
  MobilePagination,
  Text,
  ClientStatusBadge,
} from "../../shared/uiComponents";
import { SelectDataProperties } from "../../shared/uiComponents/Dropdown";
import MobileSort from "../../components/MobileSort";
import { Loader, Row, Wrapper } from "../../components/StyledComponents";
import { ClientsDataProperties } from "./tableInfo";
import Action from "./actions";

import { DispatchProperties, useSelector } from "../../redux/store";
import { clearSkillAreas } from "../../redux/State/clientSlice/skillAreaSlice";

export const clientSortData: Array<SelectDataProperties> = [
  { id: "", name: "none" },
  { id: "fullName", name: "Full Name" },
  { id: "numberOfTherapist", name: "Providers" },
  { id: "parentPhoneNumber", name: "Parent Phone Number" },
  { id: "status", name: "Status" },
];

export const clientStatusData: Array<SelectDataProperties> = [
  { id: "0", name: "Active" },
  { id: "1", name: "Paused" },
  { id: "2", name: "Discharged" },
];

const MobileView: FC<ClientsDataProperties> = (data) => {
  const dispatch = useDispatch<DispatchProperties>();

  const { query, totalNumberOfItems } = data;
  const loading = useSelector((state) => state.client.loading);

  const navigateClientHandler = () => {
    dispatch(clearSkillAreas());
  };

  return (
    <div className={"mobileView"}>
      <MobileSort
        data={clientSortData}
        hasStatus={true}
        statusData={clientStatusData}
      />
      {loading && <Loader />}
      {!loading && !totalNumberOfItems && (
        <div className={"mobileView"}>
          <Text
            title={"No results"}
            size={"smallBold"}
            className={"marginAuto"}
          />
        </div>
      )}
      {!loading &&
        !!query &&
        query.map((item, index) => (
          <Wrapper key={index}>
            <Row style={{ justifyContent: "space-between" }}>
              <div style={{ marginLeft: "16px" }}>
                <ClientStatusBadge statusCode={item.status.id} />
              </div>
              <Action item={item} />
            </Row>
            <Link to={`/clients/client/${item.id}`}>
              <Row>
                <Person />
                <Text
                  title={item.fullName}
                  className={"marginLeft8"}
                  onClick={navigateClientHandler}
                />
              </Row>
            </Link>
            <Row> 
              <Email /> <Text title={item.email} className={"marginLeft8"} />
            </Row>
            <Row>
              <Therapist />
              <Text
                title={`${item.numberOfTherapist}`}
                className={"marginLeft8"}
              />
            </Row>
            <Row>
              <Phone />
              <Text
                title={!!item.parentPhoneNumber ? item.parentPhoneNumber : "-"}
                className={"marginLeft8"}
              />
            </Row>
          </Wrapper>
        ))}
      <MobilePagination data={data} />
    </div>
  );
};

export default MobileView;
